import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

/**
 * Service utilisé pour afficher les notifications à l'utilisateur.
 */
@Injectable({
    providedIn: 'root',
})
export class NotificationService {
    constructor(protected toastr: ToastrService) {}

    /**
     * Affiche une notification d'erreur.
     * @param title : Titre de la notification.
     * @param message: Message de la notification.
     * @param options: Options de personnalisation de la notification.
     */
    public displayError(title: string, message: string, options?: any) {
        this.toastr.error(message, title, options);
    }

    /**
     * Affiche une notification d'information.
     * @param title : Titre de la notification.
     * @param message: Message de la notification.
     * @param options: Options de personnalisation de la notification.
     */
    displayInfo(title: string, message: string, options?: any) {
        this.toastr.info(message, title, options);
    }

    /**
     * Affiche une notification de succès.
     * @param title : Titre de la notification.
     * @param message: Message de la notification.
     * @param options: Options de personnalisation de la notification.
     */
    displaySuccess(title: string, message: string, options?: any) {
        this.toastr.success(message, title, options);
    }

    /**
     * Affiche une notification d'avertissement.
     * @param title : Titre de la notification.
     * @param message: Message de la notification.
     * @param options: Options de personnalisation de la notification.
     */
    displayWarning(title: string, message: string, options?: any) {
        this.toastr.warning(message, title, options);
    }
}
